import {Card, Col, Row} from 'react-bootstrap'

const NoPermissionCard = () => {
  return (
    <Row className='mb-4'>
      <Col>
        <Card>
          <Card.Body>
            <div className='d-flex flex-column align-items-center justify-content-center p-5 text-center'>
              {/* Icon */}
              <div className='mb-4'>
                <span className='fa fa-lock fa-4x text-gray-400'></span>
              </div>

              {/* Title */}
              <h3 className='text-gray-700 mb-2'>Access Restricted</h3>

              {/* The Specific Message */}
              <div className='text-muted fs-5'>
                You don't have any permissions to view this section.
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default NoPermissionCard
